import { render } from "./TopMenu.vue?vue&type=template&id=a646305a&scoped=true"
const script = {}

import "./TopMenu.vue?vue&type=style&index=0&id=a646305a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a646305a"

export default script